import React from 'react'

import { MetaText, CTALink, BodyText, Image } from '@pb/components'
import { CarouselOverflow as Carousel, HeadingMedium } from '@hm-group/fabric-components'
import { ArrowRightIcon } from '@hm-group/fabric-icons'
import { getLabelFromStorage, imageTypes } from '@pb/utils'
import cn from 'classnames'
import { Link } from 'react-router-dom'

import styles from './OrderItemNS.module.scss'
import { OrderItemNSProps } from './types'

const labels = {
  next: getLabelFromStorage('general.next'),
  prev: getLabelFromStorage('general.previous'),
}

type NumOfSlides = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
const defaultNumOfItemsPerSlide: {
  default: NumOfSlides
  xsmall: NumOfSlides
  small: NumOfSlides
  medium: NumOfSlides
  large: NumOfSlides
  xlarge: NumOfSlides
  xxl: NumOfSlides
} = {
  default: 3,
  xsmall: 3,
  small: 3,
  medium: 4,
  large: 4,
  xlarge: 6,
  xxl: 6,
}

const OrderItemNS: React.FC<OrderItemNSProps> = ({
  className,
  onClick,
  isOrderCancelled = false,
  orderAmount,
  orderDate,
  orderImages,
  orderMetaData,
  orderRoute,
  orderStatus,
}) => (
  <>
    <CTALink onClick={onClick} href={orderRoute} className={cn(styles.orderWrapper, className)}>
      <div className={styles.orderItemsAlignment}>
        <div className={styles.orderStatusItems}>
          <div className={styles.orderStatusCoulmn}>
            <HeadingMedium Tag="h2">{orderStatus}</HeadingMedium>
            <BodyText Tag={isOrderCancelled ? 'del' : 'span'}>
              <time dateTime={orderDate}>{orderDate}</time>
            </BodyText>
          </div>

          <div className={styles.orderMetaDataColumn}>
            <MetaText>{orderMetaData}</MetaText>
            <MetaText Tag={isOrderCancelled ? 'del' : 'span'}>{orderAmount}</MetaText>
          </div>
        </div>
        <div className={styles.arrowContainer}>
          <ArrowRightIcon className={styles.orderIcon} size="small" />
        </div>
      </div>
    </CTALink>
    <Carousel slideSpacing="xsmall" labels={labels} slidesPerBreakpoint={defaultNumOfItemsPerSlide}>
      {orderImages?.map((imageSrc) => (
        <Link key={imageSrc} to={orderRoute} onClick={onClick}>
          <Image
            key={imageSrc}
            url={imageSrc}
            altText={getLabelFromStorage('order.productDetails')}
            imageType={imageTypes.PRODUCT_IMAGE}
          />
        </Link>
      ))}
    </Carousel>
    <hr className={styles.line} />
  </>
)

export default OrderItemNS
